import { render, staticRenderFns } from "./Downlink.vue?vue&type=template&id=1d9d6184&"
import script from "./Downlink.vue?vue&type=script&lang=js&"
export * from "./Downlink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports